// extracted by mini-css-extract-plugin
module.exports = {"documentsFilter":"documentsFilter__nw6xt","resetButtonGroup":"resetButtonGroup__o6kME"};